module.exports = __webpack_public_path__ + "static/media/pastel_thumb_even.e51c40b0.webp";